<template>
  <section class="section is-marginless">
    <div class="columns is-centered">
      <div class="column is-half">
        <h3 class="title">Thank you for your message!</h3>
        <br />
        <h3 class="subtitle">
          We will be contacting you shortly.
          <br />
          <br />
          <button class="button is-primary is-outlined" href="" @click="reset">Ok</button>
        </h3>
      </div>
    </div>
  </section>
</template>
<script>

  export default {

    methods: {

      reset() {
        this.$router.push({name: 'Contact'})
      }

    }

  }

</script>z



// WEBPACK FOOTER //
// src/components/contact/ContactSuccess.vue